import React from 'react'
import { Tab } from 'semantic-ui-react'

import OrgDetail from './orgDetail'
import Welcome from './welcome'
import { getDetails, checkUsername } from '../utility'
import '../css/detail-view.css'

export default class DetailView extends React.Component {
  render () {
    const { match } = this.props
    const { params } = match
    const panes = checkUsername(params.username)
      ? getDetails(params.username).proposals.map((proposal, index) => {
        return {
          menuItem: {
            key: index,
            icon: index === 0 ? 'flag checkered' : false,
            content: `Proposal ${index + 1}`
          },
          render: () => (
            <Tab.Pane>
              <OrgDetail proposal={proposal} />
            </Tab.Pane>
          )
        }
      })
      : []

    return checkUsername(params.username) ? (
      <div className='scrollable-section'>
        <Tab panes={panes} />
      </div>
    ) : (
      <Welcome />
    )
  }
}
